import React, { useEffect, useState } from "react";
import QRCode from "qrcode";

/** QR generado en el dispositivo. No usa APIs externas (funciona sin cobertura). */
export default function QrDisplay({ value, size = 220, testid }) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (!value) {
      setSrc("");
      return;
    }
    let cancelled = false;
    QRCode.toDataURL(value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: "M",
      color: { dark: "#0f172a", light: "#ffffff" },
    })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc("");
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  return (
    <div className="inline-flex flex-col items-center gap-2">
      <div className="bg-white p-3 border border-slate-200 rounded-md" data-testid={testid}>
        {src ? (
          <img src={src} alt="QR DeCA" width={size} height={size} style={{ display: "block" }} />
        ) : (
          <div style={{ width: size, height: size }} className="bg-slate-100" />
        )}
      </div>
      <div className="font-mono text-[10px] text-slate-500 max-w-[240px] truncate">{value}</div>
    </div>
  );
}
